import { Box, Link, Typography } from "@mui/material"
import { OverarchingIntroductionLink } from "event-definitions"
import { If, Else } from "lib/@components/switch"
import { LocalizedMessage } from "lib/localization/localized-message"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"
import { InPdf } from "lib/@components/pdf/in-pdf"
import { NotInPdf } from "lib/@components/pdf/not-in-pdf"
import { RouterLink } from "lib/routes/router-link"

const PARA1_PREFIX_TEMPLATE = "Please refer to the "
const LINK_TEXT_TEMPLATE = "overarching introduction"
const PARA1_SUFFIX_TEMPLATE =
    " (SFG 00-01) to make sure you are of the correct skill level as indicated within the task schedule to carry out the described works. Ensure you have read and understood the manufacturer's recommendations, carried out risk assessment(s) on each item of plant to identify the correct frequency of maintenance, identified all safety procedures that need to be applied and recorded in order to carry out the work in a safe and reliable manner."
const PARA2_TEMPLATE =
    "If this asset (item of equipment/system) is within the warranty or guarantee period, it is essential that you maintain it in full accordance with the specific manufacturer's or installer's maintenance requirements. If you are in any doubt about the maintenance requirements or the warranty or guarantee period please contact the manufacturer, installer or their representative to seek clarity."

export function OverarchingIntroductionText({ overarchingIntroductionId, variant = "" }) {
    const { overrideLink } = useBoundContext()
    const { labels: translationLabels } = useTranslationContext()
    const { link } = OverarchingIntroductionLink.call({
        link: overrideLink ?? `/app/schedules/${overarchingIntroductionId}`,
        id: overarchingIntroductionId,
    })

    return (
        <>
            <Box>
                <Typography variant={variant}>
                    <If value={!!translationLabels?.overarchingPara1Prefix}>
                        {translationLabels?.overarchingPara1Prefix}
                        <Else>
                            <LocalizedMessage template={PARA1_PREFIX_TEMPLATE} />
                        </Else>
                    </If>
                    <NotInPdf>
                        <Link component={RouterLink} to={link}>
                            <If value={!!translationLabels?.overarchingLinkText}>
                                {translationLabels?.overarchingLinkText}
                                <Else>
                                    <LocalizedMessage template={LINK_TEXT_TEMPLATE} />
                                </Else>
                            </If>
                        </Link>
                    </NotInPdf>
                    <InPdf>
                        <If value={!!translationLabels?.overarchingLinkText}>
                            {translationLabels?.overarchingLinkText}
                            <Else>
                                <LocalizedMessage template={LINK_TEXT_TEMPLATE} />
                            </Else>
                        </If>
                    </InPdf>
                    <If value={!!translationLabels?.overarchingPara1Suffix}>
                        {translationLabels?.overarchingPara1Suffix}
                        <Else>
                            <LocalizedMessage template={PARA1_SUFFIX_TEMPLATE} />
                        </Else>
                    </If>
                </Typography>
            </Box>
            <Box mt={1}>
                <Typography variant={variant}>
                    <If value={!!translationLabels?.overarchingPara2}>
                        {translationLabels?.overarchingPara2}
                        <Else>
                            <LocalizedMessage template={PARA2_TEMPLATE} />
                        </Else>
                    </If>
                </Typography>
            </Box>
        </>
    )
}
